import "./contactanos.js";
import "./menu.js";
import "./reclamos.js";
import "./ubigeo.js";
import "./swiper.js";
import { initSwiper } from "./swiper.js";
import { fxContactanos, fxNosotros } from "./appFx.js";
import { ajustarEspaciadoMain } from "./utils.js";
import { redirect, actualizarURL } from "./redirect.js";

export const CAPTCHA_PUBLIC_KEY = '6LcF7oYrAAAAADRTAc4bjLiImA5l6sufYjNmgLM4';

document.addEventListener('DOMContentLoaded', ()=>{

    actualizarURL();
    const header = document.querySelector('.header');
    const headerTop = document.querySelector('.header-top') || header ;
    window.addEventListener('scroll', ()=>{
        const top = headerTop === header ? window.scrollY : headerTop.getBoundingClientRect().top;
        
        if(top <= 0 && !header.classList.contains('fixed')){
            header.classList.add('fixed');
        }else if(top >= 0 && header.classList.contains('fixed')){
            header.classList.remove('fixed');
        }
    })
    
    initSwiper();
    ajustarEspaciadoMain();
    redirect();
    fxNosotros();
    fxContactanos();
    
    window.addEventListener('resize', ajustarEspaciadoMain);


})